__turbopack_context__.v({
  "active": "style-module-scss-module__QdalIa__active",
  "label": "style-module-scss-module__QdalIa__label",
  "market-count": "style-module-scss-module__QdalIa__market-count",
  "market-info": "style-module-scss-module__QdalIa__market-info",
  "market-name": "style-module-scss-module__QdalIa__market-name",
  "market-pill": "style-module-scss-module__QdalIa__market-pill",
  "market-thumbnail": "style-module-scss-module__QdalIa__market-thumbnail",
  "markets-row": "style-module-scss-module__QdalIa__markets-row",
  "thumbnail-placeholder": "style-module-scss-module__QdalIa__thumbnail-placeholder",
  "top-markets": "style-module-scss-module__QdalIa__top-markets",
});
